import { Flex } from '@teamsparta/stack-flex';
import Image from 'next/image';

import Only from '@/components/common/Only';

import * as D from './data';
import * as S from './style';

export function Join() {
  return (
    <S.Wrapper>
      <Only.Mobile>
        <Image
          src='/images/campaign/campaign_join_bg_mobile.png'
          layout='fill'
          alt='join_bg_mobile'
          objectFit='cover'
          style={{ zIndex: '-1' }}
        />
      </Only.Mobile>
      <Only.Desktop>
        <Image
          src='/images/campaign/campaign_join_bg_desktop.png'
          layout='fill'
          alt='join_bg_desktop'
          objectFit='cover'
          style={{ zIndex: '-1' }}
        />
      </Only.Desktop>
      {D.GRASS_CAMPAIGN_JOIN_DATA.map((data, index) => {
        return (
          <Flex.Column
            key={`join-section-${index}`}
            justify='center'
            align='center'
            gap='24px'
            style={{ maxWidth: '600px', padding: '80px 16px' }}
          >
            <Flex.Column align='center' gap='16px'>
              <Flex align='center' gap='4px'>
                <S.LogoText>Made by</S.LogoText>
                <Image
                  src='/images/logo/logo.png'
                  alt='logo'
                  width={48}
                  height={14}
                  style={{ objectFit: 'contain' }}
                />
              </Flex>
              <S.Title>{data.title}</S.Title>
            </Flex.Column>

            <Flex.Column align='start' gap='16px'>
              {data.description.map((desc, index) => (
                <S.Description key={`campaign-join-description-${index}`}>
                  {desc}
                </S.Description>
              ))}
            </Flex.Column>
          </Flex.Column>
        );
      })}
    </S.Wrapper>
  );
}
